import { useEffect, useState } from "react";
import { APARTMENT } from "../ThreeScene";

const useMovement = ({ currentMode }) => {
  const [movement, setMovement] = useState({
    shiftPressed: false,
    moveForward: false,
    moveBackward: false,
    moveLeft: false,
    moveRight: false,
    lookUp: false,
    lookDown: false,
    lookLeft: false,
    lookRight: false,
  });

  const onKeyDown = (event) => {
    // console.log("currentMode", currentMode);
    switch (event.key) {
      case "ArrowUp":
        setMovement((prev) => ({
          ...prev,
          moveForward: !prev.shiftPressed,
          lookUp: prev.shiftPressed,
        }));
        break;
      case "ArrowDown":
        setMovement((prev) => ({
          ...prev,
          moveBackward: !prev.shiftPressed,
          lookDown: prev.shiftPressed,
        }));
        break;
      case "ArrowLeft":
        setMovement((prev) => ({
          ...prev,
          moveLeft: !prev.shiftPressed && currentMode === APARTMENT ? false : !prev.shiftPressed,
          lookLeft: prev.shiftPressed || currentMode === APARTMENT,
        }));
        break;
      case "ArrowRight":
        setMovement((prev) => ({
          ...prev,
          moveRight: !prev.shiftPressed && currentMode === APARTMENT ? false : !prev.shiftPressed,
          lookRight: prev.shiftPressed || currentMode === APARTMENT,
        }));
        break;
      case "Shift":
        setMovement((prev) => ({ ...prev, shiftPressed: true }));
        break;
    }
  };

  const onKeyUp = (event) => {
    // console.log("onKeyUp", event.key);
    switch (event.key) {
      case "ArrowUp":
        setMovement((prev) => ({ ...prev, moveForward: false, lookUp: false }));
        break;
      case "ArrowDown":
        setMovement((prev) => ({ ...prev, moveBackward: false, lookDown: false }));
        break;
      case "ArrowLeft":
        setMovement((prev) => ({ ...prev, moveLeft: false, lookLeft: false }));
        break;
      case "ArrowRight":
        setMovement((prev) => ({ ...prev, moveRight: false, lookRight: false }));
        break;
      case "Escape":
        // Handle escape key if needed
        break;
      case "Shift":
        setMovement((prev) => ({ ...prev, shiftPressed: false }));
        break;
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", onKeyDown);
    window.addEventListener("keyup", onKeyUp);

    return () => {
      window.removeEventListener("keydown", onKeyDown);
      window.removeEventListener("keyup", onKeyUp);
    };
  }, [currentMode]);

  return movement;
};

export default useMovement;